import type React from 'react';
import { useState, useEffect } from 'react';
import CircularProgress, { type CircularProgressProps } from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';

interface LoadingCompleteIndicatorProps extends CircularProgressProps {
  isLoading: boolean;
  isCompleted?: boolean;
}

const LoadingCompleteIndicator: React.FC<LoadingCompleteIndicatorProps> = ({ isLoading, isCompleted, size = 20, color = 'inherit' }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      {isLoading && (
        <CircularProgress size={size} color={color} />
      )}
      {isCompleted && (
        <CheckCircleIcon sx={{ color: 'green', size: 1 }} />
      )}
    </Box>
  );
};

export default LoadingCompleteIndicator;
